/**
 * Converts a PascalCase or camelCase string to a human-readable format by adding spaces before capital letters.
 *
 * @example
 * addSpacesToPascalCase('FinancialServices') // 'Financial Services'
 * addSpacesToPascalCase('RealEstate') // 'Real Estate'
 * addSpacesToPascalCase('healthCare') // 'health Care'
 *
 * @param str - The string to convert
 * @returns The string with spaces added before capital letters
 */
export function addSpacesToPascalCase (str: string): string {
  if (!str) {
    return str
  }
  return str.replace(/([A-Z])/g, ' $1').trim()
}
